export enum DocumentProcessingMode {
  Readonly,
  ReadWrite,
  Draft,
  OnlySigningPages,
}
